import React, { useState, useEffect } from 'react';
import { Steps, Radio, Result, Button, Checkbox, Input, Form } from 'antd';
import TextEvents from 'app/components/TextEvents';
import Grid from '@material-ui/core/Grid';
import isEmpty from 'app/utils/IsEmpty';
import './Quizform.css';

const { Step } = Steps;

export default function QuizForm(props) {
    const [finalAnswers, setFinalAnswers] = useState([]);
    const [listValue, setListValue] = useState();
    const [inputValue, setInputValue] = useState('');
    const [currentAnswer, setCurrentAnswer] = useState();
    const [currentQuiestion, setCurrentQuestion] = useState();
    const [quizDATAQ, setQuizDATAQ] = useState();

    useEffect(() => {
        if (typeof props.quizData.questions !== 'undefined') {
            props.quizData.questions[props.current].isAnswered ? props.setAnswered(false) : props.setAnswered(true);
        }
        if (isEmpty(finalAnswers)) {
            setFinalAnswers(props.quizData.questions);
            props.setCurrent(0)

        }
        if (typeof props.quizData.questions !== 'undefined' && typeof listValue === 'undefined') {
            typeof props.quizData.questions[props.current].correctAnswer === 'undefined' ? setListValue(null) : setListValue(props.quizData.questions[props.current].correctAnswer[0]);
        }
        if (typeof currentAnswer !== 'undefined') {
            const currentq = props.quizData.questions[props.current].listAnswers.find(i => i.idAnswer === currentAnswer);
            setCurrentQuestion(currentq);
        }
        return () => {
            if (props.isWorkCycle) {
                setInputValue('')
                if (props.quizData.questions !== undefined) {
                    if (props.quizData.questions[props.current].isAnswered !== undefined) {
                        const newCurrentAns = props.quizData.questions[props.current].correctListAnswers[0].idAnswer;
                        setCurrentAnswer(newCurrentAns);
                        const newComment = props.quizData.questions[props.current].correctListAnswers[0].comment;
                        setInputValue(newComment)
                    }
                }
            }
        }
    })

    const createQuestions = (data) => {
        const questionData = data[props.current]
        return <div>
            <TextEvents
                text={questionData.questionDescription}
                color="cotemar"
                size='subtitle'
                weight="bold"
            />
        </div>
    }

    const onChangeWhenIsWorkCycle = (e, question) => {
        setInputValue('')
        setCurrentAnswer(e.target.value)
        const answerObj = {
            idQuestion: question.idQuestion,
            idAnswer: e.target.value,
            comment: inputValue
        };
        finalAnswers[props.current]['isAnswered'] = true;
        finalAnswers[props.current]['correctListAnswers'] = [];
        finalAnswers[props.current]['correctListAnswers'].push(answerObj);
        props.setQuizQuestionsData(finalAnswers);
        setListValue(finalAnswers[props.current].correctListAnswers[0]);
        props.setAnswered(false);
    }

    const onChangeInputValue = (value, questions) => {
        setInputValue(value);
        questions[props.current].correctListAnswers[0].comment = value;
    }

    const onChange = (e, question) => {
        finalAnswers[props.current]['isAnswered'] = true;
        finalAnswers[props.current]['correctAnswer'] = [];
        finalAnswers[props.current]['correctAnswer'].push(e.target.value);
        setListValue(finalAnswers[props.current].correctAnswer[0]);
        setQuizDATAQ(finalAnswers);
        props.setQuizQuestionsData(finalAnswers);
        props.setAnswered(false);
    }

    const onChangeCheck = e => {
        finalAnswers[props.current]['isAnswered'] = true;
        finalAnswers[props.current]['correctAnswer'] = e;
        props.setQuizQuestionsData(finalAnswers);
        setListValue(finalAnswers[props.current].correctAnswer);
        props.setAnswered(false);
        setQuizDATAQ(finalAnswers);
    }

    const listAnswers = (data) => {
        if (data[data.length - 1].isAnswered === true) {
            props.setFinish(true)
        }
        return data[props.current].listAnswers.map(i => {
            return typeof props.quizData.questions === 'object' ?
                <Grid
                    xs={2}
                    item
                    key={i.idAnswer}
                >
                    <Radio.Group
                        onChange={props.isWorkCycle ? (e, q) => onChangeWhenIsWorkCycle(e, data[props.current], q) : (e) => onChange(e, data[props.current])}
                        value={Array.isArray(data[props.current].correctAnswer) ? data[props.current].correctAnswer[0] :
                            Array.isArray(data[props.current].correctListAnswers) ? data[props.current].correctListAnswers[0].idAnswer : null}
                    >
                        <Radio
                            className='ant-radio-wrapper-box'
                            value={i.idAnswer}>
                            {i.descriptionAnswer}
                        </Radio>
                    </Radio.Group>
                </Grid> : '';


        })
    }

    const checkListAnswers = (data = props.quizData.questions) => {
        if (data[data.length - 1].isAnswered === true) {
            props.setFinish(true)
        }
        return (
            <Checkbox.Group style={{ width: "100%", display: 'contents', textAlign: 'justify'}} onChange={onChangeCheck}

                defaultValue={typeof data[props.current].correctAnswer !== 'undefined' ? data[props.current].correctAnswer : null}>
                {data[props.current].listAnswers.map(i => {
                    return (
                        <Grid xs={12} item key={i.idAnswer}>
                            <Checkbox value={i.idAnswer} style={{padding: '0 25px 20px 25px'}}>{i.descriptionAnswer}</Checkbox>
                        </Grid>
                    )
                })
                }
            </Checkbox.Group>
        )
    }

    return Object.keys(props.quizData).length > 0 ?
        <div>
            <Steps size="small" current={props.current} onChange={props.onChange} className={props.classes.stepStyle}>
                {
                    props.quizData.questions.map(item =>
                    (
                        <Step key={item.idQuestion} disabled />
                    )
                    )
                }
            </Steps>
            {props.quizData.questions.length !== 0 ?
                <div className={props.classes.stepsContent}>
                    {typeof finalAnswers !== 'undefined' ? createQuestions(finalAnswers) : ''}
                    <div >
                        <Grid container
                            direction="column"
                            justify="center"
                            alignItems="flex-start"
                            className={props.classes.answersContainer}
                        >
                            {props.quizData.questions[props.current].idQuestionType === 1 ? listAnswers(props.quizData.questions) : checkListAnswers(props.quizData.questions)}
                        </Grid>
                        {props.isWorkCycle ? <Grid container
                            justify="center"
                            alignItems="flex-start"
                            className={props.classes.paddingBottomInput}>
                            {typeof currentQuiestion !== 'undefined' && currentQuiestion.isApplyComment === true && finalAnswers[props.current] !== undefined !== undefined ? <Grid xs={6} item>
                                <Form.Item
                                    validateStatus={inputValue === '' ? "error" : "success"}
                                    required
                                    help={inputValue === '' ? 'Se require llenar este campo' : ''}
                                >
                                    <Input
                                        maxLength={1000}
                                        style={{
                                            width: '100%',
                                            paddingBottom: '8px'
                                        }}
                                        defaultValue={finalAnswers !== undefined ?
                                            finalAnswers[props.current] !== undefined ?
                                                finalAnswers[props.current].correctListAnswers !== undefined ?
                                                    finalAnswers[props.current].correctListAnswers[0].comment : 'no' : 'no' : 'no'}
                                        placeholder={'Comentario'}
                                        value={inputValue}
                                        onChange={e => onChangeInputValue(e.target.value, props.quizData.questions)}
                                    />
                                </Form.Item>
                            </Grid> : ''}
                        </Grid> : ''}
                    </div>
                </div> :
                <Result
                    status="warning"
                    title="Ocurrió un problema con la operación, intente más tarde."
                    extra={
                        <Button type="primary" key="console" onClick={() => props.setChildrenVisible(false)}>
                            Regresar
                        </Button>
                    }
                />
            }
        </div> : <div />;

}